// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the navbar to extend the full-width border */
.nav-wrapper {
  position: relative;
  width: 100%;
}

.nav-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.05px;
  background-color: #DEE5ED;
  z-index: 1;
}

/* Remove underline from all links in the NavBar */
.nav-wrapper a {
  text-decoration: none;
}

/* Base styles for the desktop navbar */
.macbook-nav-bar {
  background-color: var(--semantic-background-color-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1512px;
  width: 100%;
  height: 95px;
  padding: 29px 34px 14.8px 47px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
}

.macbook-nav-bar .group {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.macbook-nav-bar .logo-instance {
  width: 127.944px;
  height: 38.025px;
}

.macbook-nav-bar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.macbook-nav-bar .column {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 33.6px;
  margin-left: auto;
  flex-shrink: 0;
}

.macbook-nav-bar .column-2 {
  display: flex;
  align-items: center;
  gap: 33.6px;
}

.macbook-nav-bar .text-wrapper-2 {
  color: var(--semantic-link-primary);
  font-family: "Inter-Regular", Helvetica;
  font-size: 16.8px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 150%;
  white-space: nowrap;
}

.macbook-nav-bar .nav-link-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4.2px;
}

.macbook-nav-bar .search-instance {
  height: 24px !important;
  position: absolute;
  left: 0;
  top: 0;
  width: 24px !important;
}

.macbook-nav-bar .chevron-down {
  height: 25.2px;
  position: relative;
  width: 25.2px;
}

.macbook-nav-bar .button-login {
  display: inline-flex;
  padding: 12.6px 21px;
  justify-content: center;
  align-items: center;
  gap: 8.4px;
  border-radius: 6.3px;
  background: var(--blue, #458BEA);
  height: 51px;
}

.macbook-nav-bar .button-signup {
  display: inline-flex;
  padding: 12.6px 21px;
  justify-content: center;
  align-items: center;
  gap: 8.4px;
  border-radius: 6.3px;
  background: var(--primitive-red);
  color: var(--primitive-white);
  height: 51px;
}

/* Mobile Header Styles */
.mobile-header {
  display: none;
  width: 100%;
  max-height: 54px;
  align-items: center;
  justify-content: space-between;
  padding: 17px 24px;
  background-color: var(--neutral-0);
  border-bottom: 1px solid var(--neutral-2);
}

.mobile-header .logo {

}

.mobile-header .menu-icon {
  width: 22px;
  height: 20px;
  margin-right: -1px;
}

/* Mobile Menu Styles */
.mobile-menu {
  position: absolute;
  top: 0;
  right: 0;
  width: 243px; /* Adjusted width */
  height: 100%;
  background-color: #fff; /* Background color of the menu */
  transition: transform 0.3s ease;
  transform: translateX(100%); /* Initially hidden */
  z-index: 2000; /* Ensure it is in front of other content */
  display: flex;
  justify-content: flex-start; /* Align items to the top */
  align-items: flex-start; /* Align items to the top */
  overflow-y: auto;
}

.mobile-menu.open {
  transform: translateX(0); /* Displayed */
}

.menu-overlay {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align items to the top */
  align-items: center;
  width: 243px;
  padding-top: 20px; /* Add padding to the top if needed */
}

.menu-overlay .overlay-content {
  background-color: #ffffff;
  width: 100%;
  text-align: center;
}

.menu-overlay .overlap-group {
  background-color: var(--neutral-0);
  border-bottom: 1px solid var(--neutral-2);
  height: 54px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
}

.menu-overlay .frame {
  height: 20px;
  width: 20px;
}

.menu-overlay .menu-item {
  color: #000000;
  font-family: "Inter-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.12px;
  line-height: 46px;
  margin: 20px 0;
  cursor: pointer;
  white-space: nowrap;
}

.menu-overlay .button-instance,
.menu-overlay .button-2 {
  width: 180px;
  margin: 20px 0;
}

/* Media Queries */
@media (max-width: 1224px) {
  .macbook-nav-bar {
    display: none;
  }

  .mobile-header {
    display: flex;
  }


  
  .mobile-header .logo img {
    position: absolute;
    top: 5px;
    max-width: 90%; /* Ensure the image doesn't overflow the container's width */
    max-height: 90%; /* Ensure the image doesn't overflow the container's height */

}
  
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/style.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,0DAA0D;EAC1D,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;;AAEA;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY,EAAE,mBAAmB;EACjC,YAAY;EACZ,sBAAsB,EAAE,iCAAiC;EACzD,+BAA+B;EAC/B,2BAA2B,EAAE,qBAAqB;EAClD,aAAa,EAAE,2CAA2C;EAC1D,aAAa;EACb,2BAA2B,EAAE,2BAA2B;EACxD,uBAAuB,EAAE,2BAA2B;EACpD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB,EAAE,cAAc;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,2BAA2B;EACxD,mBAAmB;EACnB,YAAY;EACZ,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;;;EAIA;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc,EAAE,4DAA4D;IAC5E,eAAe,EAAE,6DAA6D;;AAElF;;AAEA","sourcesContent":["/* Wrapper for the navbar to extend the full-width border */\n.nav-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.nav-wrapper::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1.05px;\n  background-color: #DEE5ED;\n  z-index: 1;\n}\n\n/* Remove underline from all links in the NavBar */\n.nav-wrapper a {\n  text-decoration: none;\n}\n\n/* Base styles for the desktop navbar */\n.macbook-nav-bar {\n  background-color: var(--semantic-background-color-primary);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1512px;\n  width: 100%;\n  height: 95px;\n  padding: 29px 34px 14.8px 47px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.macbook-nav-bar .group {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.macbook-nav-bar .logo-instance {\n  width: 127.944px;\n  height: 38.025px;\n}\n\n.macbook-nav-bar .container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.macbook-nav-bar .column {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 33.6px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.macbook-nav-bar .column-2 {\n  display: flex;\n  align-items: center;\n  gap: 33.6px;\n}\n\n.macbook-nav-bar .text-wrapper-2 {\n  color: var(--semantic-link-primary);\n  font-family: \"Inter-Regular\", Helvetica;\n  font-size: 16.8px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 150%;\n  white-space: nowrap;\n}\n\n.macbook-nav-bar .nav-link-dropdown {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4.2px;\n}\n\n.macbook-nav-bar .search-instance {\n  height: 24px !important;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 24px !important;\n}\n\n.macbook-nav-bar .chevron-down {\n  height: 25.2px;\n  position: relative;\n  width: 25.2px;\n}\n\n.macbook-nav-bar .button-login {\n  display: inline-flex;\n  padding: 12.6px 21px;\n  justify-content: center;\n  align-items: center;\n  gap: 8.4px;\n  border-radius: 6.3px;\n  background: var(--blue, #458BEA);\n  height: 51px;\n}\n\n.macbook-nav-bar .button-signup {\n  display: inline-flex;\n  padding: 12.6px 21px;\n  justify-content: center;\n  align-items: center;\n  gap: 8.4px;\n  border-radius: 6.3px;\n  background: var(--primitive-red);\n  color: var(--primitive-white);\n  height: 51px;\n}\n\n/* Mobile Header Styles */\n.mobile-header {\n  display: none;\n  width: 100%;\n  max-height: 54px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 17px 24px;\n  background-color: var(--neutral-0);\n  border-bottom: 1px solid var(--neutral-2);\n}\n\n.mobile-header .logo {\n\n}\n\n.mobile-header .menu-icon {\n  width: 22px;\n  height: 20px;\n  margin-right: -1px;\n}\n\n/* Mobile Menu Styles */\n.mobile-menu {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 243px; /* Adjusted width */\n  height: 100%;\n  background-color: #fff; /* Background color of the menu */\n  transition: transform 0.3s ease;\n  transform: translateX(100%); /* Initially hidden */\n  z-index: 2000; /* Ensure it is in front of other content */\n  display: flex;\n  justify-content: flex-start; /* Align items to the top */\n  align-items: flex-start; /* Align items to the top */\n  overflow-y: auto;\n}\n\n.mobile-menu.open {\n  transform: translateX(0); /* Displayed */\n}\n\n.menu-overlay {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start; /* Align items to the top */\n  align-items: center;\n  width: 243px;\n  padding-top: 20px; /* Add padding to the top if needed */\n}\n\n.menu-overlay .overlay-content {\n  background-color: #ffffff;\n  width: 100%;\n  text-align: center;\n}\n\n.menu-overlay .overlap-group {\n  background-color: var(--neutral-0);\n  border-bottom: 1px solid var(--neutral-2);\n  height: 54px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 20px;\n}\n\n.menu-overlay .frame {\n  height: 20px;\n  width: 20px;\n}\n\n.menu-overlay .menu-item {\n  color: #000000;\n  font-family: \"Inter-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0.12px;\n  line-height: 46px;\n  margin: 20px 0;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.menu-overlay .button-instance,\n.menu-overlay .button-2 {\n  width: 180px;\n  margin: 20px 0;\n}\n\n/* Media Queries */\n@media (max-width: 1224px) {\n  .macbook-nav-bar {\n    display: none;\n  }\n\n  .mobile-header {\n    display: flex;\n  }\n\n\n  \n  .mobile-header .logo img {\n    position: absolute;\n    top: 5px;\n    max-width: 90%; /* Ensure the image doesn't overflow the container's width */\n    max-height: 90%; /* Ensure the image doesn't overflow the container's height */\n\n}\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
